var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Emit } from 'vue-property-decorator';
import MaterialIcons from '@/components/material-icons.vue';
var ProjectSortButton = /** @class */ (function (_super) {
    __extends(ProjectSortButton, _super);
    function ProjectSortButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentSort = 'created_desc';
        _this.sortOptions = [
            { label: '作成が新しい', value: 'created_desc' },
            { label: '作成が古い', value: 'created_asc' },
            { label: '更新が新しい', value: 'updated_desc' },
            { label: '更新が古い', value: 'updated_asc' }
        ];
        return _this;
    }
    Object.defineProperty(ProjectSortButton.prototype, "currentSortLabel", {
        get: function () {
            var _this = this;
            var current = this.sortOptions.find(function (opt) { return opt.value === _this.currentSort; });
            return current ? current.label : '作成が新しい';
        },
        enumerable: false,
        configurable: true
    });
    ProjectSortButton.prototype.handleSortChange = function (value) {
        this.currentSort = value;
        return value;
    };
    __decorate([
        Emit('sort-change')
    ], ProjectSortButton.prototype, "handleSortChange", null);
    ProjectSortButton = __decorate([
        Component({
            components: { MaterialIcons: MaterialIcons }
        })
    ], ProjectSortButton);
    return ProjectSortButton;
}(Vue));
export default ProjectSortButton;
